import apiClient from './client';
import { AuthResponse } from './auth.api';

export type ProfileUser = AuthResponse['user'] & { countryCode?: string };

export const profileApi = {
  get: async (): Promise<ProfileUser> => {
    const response = await apiClient.get('/business/profile');
    return response.data.data;
  },

  update: async (data: { name: string; businessName: string; address?: string }): Promise<ProfileUser> => {
    const response = await apiClient.patch('/business/profile', data);
    return response.data.data;
  },

  sendContactOtp: async (data: {
    channel: 'phone' | 'email';
    phone?: string;
    countryCode?: string;
    email?: string;
  }) => {
    const response = await apiClient.post('/business/profile/contact/send-otp', data);
    return response.data;
  },

  verifyContactOtp: async (data: {
    channel: 'phone' | 'email';
    otp: string;
    phone?: string;
    countryCode?: string;
    email?: string;
  }): Promise<ProfileUser> => {
    const response = await apiClient.post('/business/profile/contact/verify-otp', data);
    return response.data.data;
  },
};
